import { combineReducers } from "redux";

import User from "./User";
import Time from "./Time";

export default combineReducers({
  User,
  Time,
});
